import { jsonDelete, jsonGet, jsonPost, jsonPut, jsonPatch } from "../api";

// Monitor CRUD operations
export const fetchBrandMonitors = async (brandId) =>
  await jsonGet(`brands/${brandId}/monitors`);

export const fetchBrandMonitorById = async (brandId, monitorId) =>
  await jsonGet(`brands/${brandId}/monitors/${monitorId}`);

export const createBrandMonitor = async (brandId, monitorData) =>
  await jsonPost(`brands/${brandId}/monitors`, monitorData);

export const deleteBrandMonitor = async (brandId, monitorId) =>
  await jsonDelete(`brands/${brandId}/monitors/${monitorId}`);

export const updateBrandMonitor = async (brandId, monitorId, dto) =>
  await jsonPatch(`brands/${brandId}/monitors/${monitorId}`, dto);

// Monitor results operations
export const fetchMonitorResults = async (brandId, monitorId, resultId) =>
  await jsonGet(`brands/${brandId}/monitors/${monitorId}/results/${resultId}`);

export const fetchMonitorResultDetails = async (brandId, monitorId, resultId) =>
  await jsonGet(
    `brands/${brandId}/monitors/${monitorId}/results/${resultId}/details`
  );

export const fetchAllMonitorResults = async (brandId, monitorId) =>
  await jsonGet(`brands/${brandId}/monitors/${monitorId}/results`);

// Automated query creation
export const createAutomatedQueries = async (brandId) =>
  await jsonPost(`brands/${brandId}/queries`);

export const findAllAnalysisRuns = async (brandId) =>
  await jsonGet(`brands/${brandId}/analysis-runs`);

export const findSingleAnalysisRun = async (brandId, analysisRunId) =>
  await jsonGet(`brands/${brandId}/analysis-runs/${analysisRunId}`);

export const findAllAnalysisRunResults = async (brandId, monitorRunId) =>
  await jsonGet(`brands/${brandId}/analysis-runs/${monitorRunId}/invocations`);

export const regenerateAnalysis = async (brandId, analysisRunId) =>
  await jsonPost(`brands/${brandId}/analysis-runs/${analysisRunId}/regenerate`);
